<template>
  <v-form ref="form">
    <v-card disabled class="elevation-0 px-0 ma-0">
      <!-- <v-card-title>
          <span class="font-weight-regular body-1">ICMS Geral</span>
      </v-card-title> -->

      <!-- <v-card-text> -->
      <v-row disabled>
        <v-col cols="12" sm="12" md="6">
          <v-text-field
            v-model="entry.taxationGroup.ncm.text"
            label="NCM"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6">
          <v-text-field
            v-model="entry.taxationGroup.name"
            label="Grupo de Tributação"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            v-model="entry.taxRegimeTypeName"
            label="Regime Tributário"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            v-model="entry.operationDestinationTypeName"
            label="Destino de Operação"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- </v-card-text> -->
    </v-card>

    <v-tabs color="#37BC9B">
      <v-tab>ICMS</v-tab>
      <v-tab>PIS</v-tab>
      <v-tab>COFINS</v-tab>
      <v-tab disabled>IPI</v-tab>
      <v-tab>IBS/CBS</v-tab>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">ICMS Geral</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      label="Origem"
                      :items="extraData.allIcmsOrigins"
                      v-model="entry.icmsOriginId"
                      v-bind="getObject('icmsOriginId')"
                      clearable
                      @click:clear="$nextTick(() => entry.icmsOriginId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-if="entry.taxRegimeType == 'regime_normal'"
                      label="CST"
                      :items="extraData.allIcmsCsts"
                      v-model="entry.icmsCstId"
                      v-bind="getObject('icmsCstId')"
                      clearable
                      @click:clear="$nextTick(() => entry.icmsCstId = null)"
                      autocomplete="new"
                    />
                    <v-autocomplete
                      v-else
                      label="CSOSN"
                      :items="extraData.allIcmsCsosns"
                      v-model="entry.icmsCsosnId"
                      v-bind="getObject('icmsCsosnId')"
                      clearable
                      @click:clear="$nextTick(() => entry.icmsCsosnId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">ICMS Normal</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      label="Mod. det. BC"
                      :items="extraData.allIcmsModBcs"
                      v-model="entry.icmsModBcId"
                      v-bind="getObject('icmsModBcId')"
                      clearable
                      @click:clear="$nextTick(() => entry.icmsModBcId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                  <!-- <v-col cols="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPicms')"
                      :inputData.sync="entry.icmsPicms"
                      mask-type="3v2-4"
                      label="Alíq. ICMS"
                    />
                  </v-col> -->

                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPredBc')"
                      :inputData.sync="entry.icmsPredBc"
                      mask-type="3v2-4"
                      label="Red. BC"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1"
                  >ICMS Substituição Tributária (ST)</span
                >
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      label="Mod. det. BCST"
                      :items="extraData.allIcmsModBcSts"
                      v-model="entry.icmsModBcStId"
                      v-bind="getObject('icmsModBcStId')"
                      clearable
                      @click:clear="$nextTick(() => entry.icmsModBcStId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPicmsSt')"
                      :inputData.sync="entry.icmsPicmsSt"
                      mask-type="3v2-4"
                      label="Alíq. ICMSST"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPredBcSt')"
                      :inputData.sync="entry.icmsPredBcSt"
                      mask-type="3v2-4"
                      label="Red. BCST"
                      prefix="%"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPmvaSt')"
                      :inputData.sync="entry.icmsPmvaSt"
                      mask-type="3v2-4"
                      label="MVA ICMSST"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1"
                  >Fundo de Combate à Pobreza</span
                >
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPfcp')"
                      :inputData.sync="entry.icmsPfcp"
                      mask-type="3v2-4"
                      label="FCP"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1"
                  >Fundo de Combate à Pobreza retido por ST</span
                >
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPfcpSt')"
                      :inputData.sync="entry.icmsPfcpSt"
                      mask-type="3v2-4"
                      label="ICMS FCPST"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">ICMS Desonerado</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsVicmsDeson')"
                      :inputData.sync="entry.icmsVicmsDeson"
                      mask-type="13v2"
                      label="Vlr. Desonerado"
                    />
                  </v-col>
                  <v-col cols="12" sm="6"> 
                    <v-autocomplete
                      label="Motivo"
                      :items="extraData.allIcmsMotDesons"
                      v-model="entry.icmsMotDesonId"
                      v-bind="getObject('icmsMotDesonId')"
                      clearable
                      @click:clear="$nextTick(() => entry.icmsMotDesonId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">Crédito ICMS SN</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPcredSn')"
                      :inputData.sync="entry.icmsPcredSn"
                      mask-type="3v2-4"
                      label="Alíq. Cálculo"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsVcredIcmsSn')"
                      :inputData.sync="entry.icmsVcredIcmsSn"
                      mask-type="13v2"
                      label="Vlr. Crédito"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">ICMS Efetivo</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPredBcEfet')"
                      :inputData.sync="entry.icmsPredBcEfet"
                      mask-type="3v2-4"
                      label="Red. BC Efet."
                      prefix="%"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPicmsEfet')"
                      :inputData.sync="entry.icmsPicmsEfet"
                      mask-type="3v2-4"
                      label="Alíq. ICMS Efet."
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">ICMS Diferimento</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      v-bind="getObject('icmsPdif')"
                      :inputData.sync="entry.icmsPdif"
                      mask-type="3v2-4"
                      label="Diferimento"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">ICMS Retido</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsVbcStRet')"
                      :inputData.sync="entry.icmsVbcStRet"
                      mask-type="13v2"
                      label="Vlr. BC ICMSST Ret."
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsVicmsSubstituto')"
                      :inputData.sync="entry.icmsVicmsSubstituto"
                      mask-type="13v2"
                      label="Vlr. ICMS próprio"
                      prefix="Subst."
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsVicmsStRet')"
                      :inputData.sync="entry.icmsVicmsStRet"
                      mask-type="13v2"
                      label="Vlr. ICMSST Ret."
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsPst')"
                      :inputData.sync="entry.icmsPst"
                      mask-type="3v2-4"
                      label="Alíq. Cons. Final"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsVbcFcpStRet')"
                      :inputData.sync="entry.icmsVbcFcpStRet"
                      mask-type="13v2"
                      label="Vlr. BCFCP Ret. Ant."
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsPfcpStRet')"
                      :inputData.sync="entry.icmsPfcpStRet"
                      mask-type="3v2-4"
                      label="FCP Ret. Ant. ST"
                      prefix="%"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <MaskedTextField
                      v-bind="getObject('icmsVfcpStRet')"
                      :inputData.sync="entry.icmsVfcpStRet"
                      mask-type="13v2"
                      label="Vlr. FCP Ret. Ant. ST"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">PIS Geral</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      label="CST"
                      :items="extraData.allPisCsts"
                      v-model="entry.pisCstId"
                      v-bind="getObject('pisCstId')"
                      clearable
                      @click:clear="$nextTick(() => entry.pisCstId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1"
                  >PIS Tributado pela Alíquota</span
                >
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <MaskedTextField
                      :inputData.sync="entry.pisPpis"
                      v-bind="getObject('pisPpis')"
                      mask-type="3v2-4"
                      label="Alíquota do PIS"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">
                  PIS Tributado por Qtde
                </span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <MaskedTextField
                      :inputData.sync="entry.pisValiqProd"
                      v-bind="getObject('pisValiqProd')"
                      mask-type="11v0-4"
                      label="Alíquota do PIS"
                      prefix="R$"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card outlined disabled>
              <v-card-title>
                <span class="font-weight-regular body-1">PIS Total</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      :inputData.sync="entry.pisVBC"
                      v-bind="getObject('pisVBC')"
                      mask-type="13v2"
                      label="Valor da BC do PIS"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      :inputData.sync="entry.pisVPIS"
                      v-bind="getObject('pisVPIS')"
                      mask-type="13v2"
                      label="Valor do PIS"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">COFINS Geral</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      label="CST"
                      :items="extraData.allCofinsCsts"
                      v-model="entry.cofinsCstId"
                      v-bind="getObject('cofinsCstId')"
                      clearable
                      @click:clear="$nextTick(() => entry.cofinsCstId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">
                  COFINS Tributado pela Alíquota
                </span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <MaskedTextField
                      :inputData.sync="entry.cofinsPcofins"
                      v-bind="getObject('cofinsPcofins')"
                      mask-type="3v2-4"
                      label="Alíquota da COFINS"
                      prefix="%"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">
                  COFINS Tributado por Qtde
                </span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <MaskedTextField
                      :inputData.sync="entry.cofinsValiqProd"
                      v-bind="getObject('cofinsValiqProd')"
                      mask-type="11v0-4"
                      label="Alíquota da COFINS"
                      prefix="R$"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card outlined disabled>
              <v-card-title>
                <span class="font-weight-regular body-1">COFINS Total</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      :inputData.sync="entry.cofinsVBC"
                      v-bind="getObject('cofinsVBC')"
                      mask-type="13v2"
                      label="Valor da BC da COFINS"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <MaskedTextField
                      :inputData.sync="entry.cofinsVCOFINS"
                      v-bind="getObject('cofinsVCOFINS')"
                      mask-type="13v2"
                      label="Valor da COFINS"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          aba IPI
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-card outlined :disabled="readOnly">
              <v-card-title>
                <span class="font-weight-regular body-1">IBS/CBS</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      label="CST"
                      :items="extraData.allIbsCbsCsts"
                      v-model="entry.ibsCbsCstId"
                      v-bind="getObject('ibsCbsCstId')"
                      @input="selectCst"
                      clearable
                      item-value="id"
                      item-text="text"
                      @click:clear="$nextTick(() => entry.ibsCbsCstId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      label="cClassTrib"
                      :items="cClassTribs"
                      v-model="entry.ibsCbsCclasstribId"
                      v-bind="getObject('ibsCbsCclasstribId')"
                      @input="selectClassTrib"
                      clearable
                      item-value="id"
                      item-text="text"
                      @click:clear="$nextTick(() => entry.ibsCbsCclasstribId = null)"
                      autocomplete="new"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card outlined :disabled="readOnly" style="margin-top: 8px;" v-if="cst">
              <v-card-title>
                <span class="font-weight-regular body-1">Dados CST</span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGibscbs"
                      inset 
                      :label="`ind_gIBSCBS: ${cst.indGibscbs ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGibscbsmono" 
                      inset
                      :label="`indGibscbsmono: ${cst.indGibscbsmono ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGred" 
                      inset 
                      :label="`indGred: ${cst.indGred ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGdif" 
                      inset 
                      :label="`indGdif: ${cst.indGdif ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGtransfcred" 
                      inset 
                      :label="`indGtransfcred: ${cst.indGtransfcred ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGcredpresibszfm" 
                      inset 
                      :label="`indGcredpresibszfm: ${cst.indGcredpresibszfm ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indGajustecompet" 
                      inset 
                      :label="`indGajustecompet: ${cst.indGajustecompet ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="cst.indRedutorbc" 
                      inset 
                      :label="`indRedutorbc: ${cst.indRedutorbc ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                </v-row>

              </v-card-text>
            </v-card>

            <v-card outlined :disabled="readOnly" style="margin-top: 8px;x  " v-if="classTrib">
              <v-card-title>
                <span class="font-weight-regular body-1">Dados cClassTrib</span>
              </v-card-title>

              <v-card-text>
                <v-row>

                  <v-col cols="12">
                   <v-textarea v-model="classTrib.lc" v-bind="getObject('classtrib.lc')" label="LC" outlined
                     :disabled="readOnly" autocomplete="off"></v-textarea>
                  </v-col>

                   <v-col cols="12">
                    <v-textarea v-model="classTrib.essay" v-bind="getObject('classtrib.essay')" label="Redação" outlined
                      :disabled="readOnly" autocomplete="off"></v-textarea>
                   </v-col>


                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indGtribregular"
                      inset 
                      :label="`indGtribregular: ${classTrib.indGtribregular ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indGcredpresoper" 
                      inset
                      :label="`indGcredpresoper: ${classTrib.indGcredpresoper ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indGmonopadrao" 
                      inset 
                      :label="`indGmonopadrao: ${classTrib.indGmonopadrao ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indGmonoreten" 
                      inset 
                      :label="`indGmonoreten: ${classTrib.indGmonoreten ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indGmonoret" 
                      inset 
                      :label="`indGmonoret: ${classTrib.indGmonoret ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indGmonodif" 
                      inset 
                      :label="`indGmonodif: ${classTrib.indGmonodif ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFeABI" 
                      inset 
                      :label="`indNFeABI: ${classTrib.indNFeABI ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFe" 
                      inset 
                      :label="`indNFe: ${classTrib.indNFe ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFCe" 
                      inset 
                      :label="`indNFCe: ${classTrib.indNFCe ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indCTe" 
                      inset 
                      :label="`indCTe: ${classTrib.indCTe ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indCTeOS" 
                      inset 
                      :label="`indCTeOS: ${classTrib.indCTeOS ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indBPe" 
                      inset 
                      :label="`indBPe: ${classTrib.indBPe ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indBPeTA" 
                      inset 
                      :label="`indBPeTA: ${classTrib.indBPeTA ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indBPeTM"
                      inset 
                      :label="`indBPeTM: ${classTrib.indBPeTM ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNF3e" 
                      inset 
                      :label="`indNF3e: ${classTrib.indNF3e ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFSe" 
                      inset 
                      :label="`indNFSe: ${classTrib.indNFSe ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFSeVia" 
                      inset 
                      :label="`indNFSeVia: ${classTrib.indNFSeVia ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFCom" 
                      inset 
                      :label="`indNFCom: ${classTrib.indNFCom ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFAg" 
                      inset 
                      :label="`indNFAg: ${classTrib.indNFAg ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indNFGas" 
                      inset 
                      :label="`indNFGas: ${classTrib.indNFGas ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-switch 
                      v-model="classTrib.indDERE" 
                      inset 
                      :label="`indDERE: ${classTrib.indDERE ? 'Sim' : 'Não'}`">
                    </v-switch>
                  </v-col>

                </v-row>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
       
      </v-tab-item>
    </v-tabs>
  </v-form>
</template>

<script>
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag'

export default {
  data() {
    return {
      cClassTribs: [],
      loading: false,
      cst: null,
      classTrib: null,
      entryAttributes: {
        pisPpis: {
          disabled: true
        },
        pisValiqProd: {
          disabled: true
        },
        cofinsPcofins: {
          disabled: true
        },
        cofinsValiqProd: {
          disabled: true
        },
        pisCstId: {
          events: [
            {
              change: this.refreshPisFieldsValidations
            }
          ]
        },
        CofinsCstId: {
          events: [
            {
              change: this.refreshCofinsFieldsValidations
            }
          ]
        }
      }
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    if(this.entry.ibsCbsCclasstribId){
      this.selectCst();
      this.selectClassTrib();
    }
    
    // console.log(this.entry)
  },
  methods: {
    teste: function() {
      // console.log("clear");
      // setTimeout(() => {
        this.entry.icmsModBcId = null;
      // }, 1000);
      
    },

    selectCst: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: ALL_CCLASS_TRIBS,
          fetchPolicy: "no-cache",
          variables: {
            id: this.entry.ibsCbsCstId
          }
        })
        .then(response => {
          this.cClassTribs = response.data.globalContext.allCclasstribsForCst;
          this.cst = response.data.globalContext.cst;
          // console.log("cst",this.cst);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },

    selectClassTrib: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: CCLASS_TRIB,
          fetchPolicy: "no-cache",
          variables: {
            id: this.entry.ibsCbsCclasstribId
          }
        })
        .then(response => {
          this.classTrib = response.data.globalContext.cclasstrib;
          // console.log("classtrib",this.classTrib);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },

    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    disableAllPisFields: function() {},
    refreshPisFieldsValidations: function(pisCst) {
      var cstValidations = this.entry.extraValidations.pis[pisCst];
      // console.log(pisCst);

      Object.keys(cstValidations).forEach(key => {
        // if(cstValidations)
      });
      var enabledFields = _.pickBy(cstValidations, function(value, key) {
        return value.enabled;
      });
      var requiredFields = _.pickBy(cstValidations, function(value, key) {
                    return value.required;
      });
      // console.log("enabledFields", enabledFields);
      // console.log("requiredFields", requiredFields);
      // console.log(this.entry.extraValidations.pis[`${pisCst}`]);
      // console.log(this.$refs.pisPpis)
      // this.entryAttributes.pisPpis.disabled = false;

      // console.log(this.$refs.tab2)
    },
    refreshCofinsFieldsValidations: function(cofinsCst) {}
  }
};


const ALL_CCLASS_TRIBS = gql `
  query ($id: ID!) {
    globalContext{
      allCclasstribsForCst(cstId: $id) {
        id
        name
        description
        text
      }
      cst(id: $id){
        id
        description
        code
        indGibscbs
        indGibscbsmono
        
        indGred
        indGdif

        indGtransfcred
        indGcredpresibszfm

        indGajustecompet
        indRedutorbc
      }
    }
  }
`
const CCLASS_TRIB = gql `
  query ($id: ID!) {
    globalContext{
      cclasstrib(id: $id){
        id
        code
        name
        text
        description
        essay
        lc
        pRedIBS
        pRedCBS
        indGtribregular
        indGcredpresoper
        indGmonopadrao
        indGmonoreten
        indGmonoret

        indGmonodif
        indGestornocred

        dIniVig
        dFimVig
        dataAtualizacao

        indNFeABI
        indNFe
        indNFCe
        indCTe
        indCTeOS
        indBPe
        indBPeTA
        indBPeTM
        indNF3e
        indNFSe
        indNFSeVia
        indNFCom
        indNFAg
        indNFGas
        indDERE
      }
    }
  }
`

</script>

<style scoped></style>
